import { Team, TeamTop } from "../components";
import { Layout } from "../components/Layout";
export const TeamPage = () => {
  return (
    <Layout>
      <TeamTop />
      <Team />
    </Layout>
  );
};
